export default function PresentSection() {
  return (
    <section id="present" className="relative w-full bg-background-50 py-28 md:py-40 overflow-hidden">
      {/* Background Decoration Text */}
      <div className="absolute top-2 left-1/2 -translate-x-1/2 pointer-events-none select-none">
        <p
          className="font-heading text-[48px] sm:text-[72px] md:text-[140px] lg:text-[180px] tracking-[0.1em] text-foreground-100/80 whitespace-nowrap"
          style={{ fontWeight: 300 }}
        >
          PRESENT
        </p>
      </div>

      <div className="relative z-10 w-full px-6 md:px-16">
        {/* Top Label & Heading */}
        <div className="text-center mb-16 md:mb-24">
          <p className="font-sans text-[12px] tracking-[0.2em] text-foreground-400 mb-6">
            PRESENT ／ ご来場特典
          </p>
          <h2
            className="font-heading text-[22px] md:text-[30px] tracking-[0.1em] leading-[1.8] text-foreground-950"
            style={{ fontWeight: 300 }}
          >
            心を満たす、美しい髪へのギフト。
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left: Product Image with Badge */}
          <div className="w-full lg:w-[45%] relative flex-shrink-0">
            <div className="flex items-end justify-center gap-4 md:gap-8">
              <img
                src="https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/a6906145-8594-45b1-add3-f2e057bd1c9d_compressed_unnamed.webp"
                alt="ReFa BEAUTECH SHAMPOO"
                className="w-[46%] max-w-[260px] h-auto object-contain"
              />
              <img
                src="https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/0c5a5b83-5eef-40d5-a75e-3994c9f816ca_compressed_unnamed.webp"
                alt="ReFa BEAUTECH TREATMENT"
                className="w-[46%] max-w-[260px] h-auto object-contain"
              />
            </div>

            {/* LIMITED 100 Badge */}
            <div className="absolute -top-10 -right-2 md:-right-8 w-[80px] h-[80px] md:w-[100px] md:h-[100px] rounded-full bg-primary-500 flex flex-col items-center justify-center">
              <p
                className="font-sans text-[10px] md:text-[11px] tracking-[0.1em] text-background-50"
                style={{ fontWeight: 400 }}
              >
                LIMITED
              </p>
              <p
                className="font-heading text-xl md:text-[28px] tracking-[0.05em] text-background-50 leading-none my-0.5"
                style={{ fontWeight: 400 }}
              >
                100
              </p>
              <p
                className="font-sans text-[9px] md:text-[10px] tracking-[0.1em] text-background-50"
                style={{ fontWeight: 300 }}
              >
                GUESTS
              </p>
            </div>
          </div>

          {/* Right: Text Content */}
          <div className="w-full lg:w-[50%] flex flex-col justify-center">
            <p className="font-sans text-[12px] tracking-[0.15em] text-foreground-400 mb-4">
              GIFT ITEM
            </p>

            <h3
              className="font-heading text-[22px] md:text-[26px] tracking-[0.08em] leading-[1.6] text-foreground-950 mb-8"
              style={{ fontWeight: 300 }}
            >
              ReFa BEAUTECH
              <br />
              SHAMPOO &amp; TREATMENT
            </h3>

            <p
              className="font-sans text-[15px] md:text-[16px] tracking-[0.04em] leading-[2.4] text-foreground-600 mb-10"
              style={{ fontWeight: 300 }}
            >
              髪の美しさを引き出す、独自のカスタムケア成分を配合したプレミアムケア。
              <br />
              毎日のバスタイムを、まるでサロンのようなひとときへ。
              <br />
              GIAZOが目指す「上質な日常」を、ご自宅でもお愉しみください。
            </p>

            {/* 3 Features */}
            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-drop-line text-lg text-foreground-400"></i>
                </div>
                <div>
                  <p
                    className="font-sans text-[15px] tracking-[0.05em] text-foreground-700 mb-1"
                    style={{ fontWeight: 400 }}
                  >
                    カスタムケア
                  </p>
                  <p
                    className="font-sans text-[14px] tracking-[0.03em] text-foreground-400"
                    style={{ fontWeight: 300 }}
                  >
                    髪と地肌を整える独自処方
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-vip-diamond-line text-lg text-foreground-400"></i>
                </div>
                <div>
                  <p
                    className="font-sans text-[15px] tracking-[0.05em] text-foreground-700 mb-1"
                    style={{ fontWeight: 400 }}
                  >
                    サロン品質
                  </p>
                  <p
                    className="font-sans text-[14px] tracking-[0.03em] text-foreground-400"
                    style={{ fontWeight: 300 }}
                  >
                    自宅で叶える、しっとりとまとまる仕上がり
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-sparkling-line text-lg text-foreground-400"></i>
                </div>
                <div>
                  <p
                    className="font-sans text-[15px] tracking-[0.05em] text-foreground-700 mb-1"
                    style={{ fontWeight: 400 }}
                  >
                    ラグジュアリー
                  </p>
                  <p
                    className="font-sans text-[14px] tracking-[0.03em] text-foreground-400"
                    style={{ fontWeight: 300 }}
                  >
                    エレガントな香りで満たされる、上質なバスタイム
                  </p>
                </div>
              </div>
            </div>

            {/* Condition */}
            <div className="border-t border-foreground-200/60 pt-6">
              <p className="font-sans text-[12px] tracking-[0.1em] text-foreground-400 mb-2">
                抽選対象条件
              </p>
              <p
                className="font-sans text-[14px] tracking-[0.04em] leading-[2.0] text-foreground-500"
                style={{ fontWeight: 300 }}
              >
                Webから事前予約の上、期間中（2026年7月20日〜8月30日）に対象の4展示場へご来場いただき、アンケートにお答えいただいたご家族の代表者1名様。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}